import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { lossReasons, monthly, sources, treatments, uploads } from '../data/mockData';
import { Funnel, LossReasons } from './Dashboard';

const { FiUploadCloud, FiDownload, FiCheckCircle, FiPlus, FiTrash2, FiSave, FiDatabase } = FiIcons;

export function Reports() {
  const maxMonthly = Math.max(...monthly.map((item) => item.value));

  return (
    <div className="data-page">
      <PageTitle title="التقارير" subtitle="اتجاهات واضحة لفهم أين ولماذا تتسرب الإيرادات." />
      <div className="report-grid">
        <article className="panel trend-panel">
          <h2>اتجاه التسرب المالي</h2><p>الإيرادات المقدّرة المفقودة شهريًا</p>
          <div className="trend-chart">
            {monthly.map((item) => <div key={item.month}><span>{(item.value / 1000).toFixed(0)}k</span><i style={{ height: `${item.value / maxMonthly * 100}%` }} /><small>{item.month}</small></div>)}
          </div>
        </article>
        <article className="panel recoverable-report">
          <small>الإيرادات المحتملة القابلة للاستعادة</small><strong>21,200 ر.س</strong><span>من 17 فرصة ذات أولوية</span>
          <div className="recoverable-ring">31%</div>
        </article>
      </div>
      <div className="dashboard-grid"><LossReasons /><ServiceReport /></div>
      <Funnel />
      <article className="panel source-panel">
        <h2>أداء مصادر العملاء</h2><p>مقارنة التحويل والتسرب المالي المقدّر حسب المصدر</p>
        <div className="table-wrap">
          <table><thead><tr><th>المصدر</th><th>العملاء</th><th>التحويل</th><th>الإيرادات المقدّرة</th><th>التسرب المقدّر</th></tr></thead>
            <tbody>{sources.map((source) => <tr key={source.name}><td><b>{source.name}</b></td><td>{source.leads}</td><td>{source.conversion}%</td><td>{source.revenue.toLocaleString()} ر.س</td><td className="negative">{source.leakage.toLocaleString()} ر.س</td></tr>)}</tbody>
          </table>
        </div>
      </article>
    </div>
  );
}

function ServiceReport() {
  return (
    <article className="panel">
      <h2>التسرب حسب الخدمة</h2><p>ترتيب الخدمات حسب الإيرادات المقدّرة المفقودة</p>
      <div className="compact-ranks">{treatments.map((item, index) => <div key={item.name}><span className="rank">{index + 1}</span><span><b>{item.name}</b><small>{item.lost} فرصة</small></span><strong>{item.value.toLocaleString()} ر.س</strong></div>)}</div>
    </article>
  );
}

export function UploadPage({ navigate }) {
  const sample = () => {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(new Blob(['lead_date,lead_id,service,source,estimated_value,status,loss_reason'], { type: 'text/csv' }));
    link.download = 'cencey-sample.csv';
    link.click();
  };

  return (
    <div className="data-page">
      <PageTitle title="رفع البيانات" subtitle="أضف دفعة جديدة من بيانات العملاء المحتملين للتحليل." />
      <section className="upload-banner">
        <SafeIcon icon={FiUploadCloud} />
        <div><h2>رفع ملف جديد</h2><p>CSV أو Excel، بحد أقصى 10 ميجابايت.</p></div>
        <label className="btn primary">اختيار ملف<input type="file" hidden onChange={() => navigate('/analysis')} /></label>
        <button className="btn secondary" onClick={sample}><SafeIcon icon={FiDownload} /> تحميل نموذج CSV</button>
      </section>
      <article className="panel">
        <h2>الملفات السابقة</h2>
        <div className="upload-list">{uploads.map((upload) => <div key={upload.name}><span className="file-icon"><SafeIcon icon={FiDatabase} /></span><span><b>{upload.name}</b><small>رُفع في {upload.date}</small></span><span>{upload.leads} عميل</span><span className="status success"><SafeIcon icon={FiCheckCircle} /> تم التحليل</span></div>)}</div>
      </article>
    </div>
  );
}

export function Settings() {
  const [services, setServices] = useState(treatments.slice(0, 4));
  const remove = (index) => setServices(services.filter((_, itemIndex) => index !== itemIndex));

  return (
    <div className="data-page">
      <PageTitle title="الإعدادات" subtitle="إدارة معلومات العيادة والخدمات والفريق." />
      <div className="settings-layout">
        <section className="panel settings-section"><h2>بيانات العيادة</h2><div className="form-grid"><Field label="اسم العيادة" value="عيادات ابتسامة الرياض" /><Field label="الدولة" value="السعودية" /><Field label="المدينة" value="الرياض" /><Field label="العملة" value="ر.س — الريال السعودي" /></div><button className="btn primary"><SafeIcon icon={FiSave} /> حفظ التغييرات</button></section>
        <section className="panel settings-section"><h2>الخدمات</h2>{services.map((service, index) => <div className="settings-service" key={service.name}><input defaultValue={service.name} /><div><input type="number" defaultValue={service.value / Math.max(service.lost, 1)} /><span>ر.س</span></div><button onClick={() => remove(index)}><SafeIcon icon={FiTrash2} /></button></div>)}<button className="add-button" onClick={() => setServices([...services, { name: 'خدمة جديدة', value: 1000, lost: 1 }])}><SafeIcon icon={FiPlus} /> إضافة خدمة</button></section>
        <section className="panel settings-section"><h2>الفريق</h2>{['سارة محمد', 'نورة أحمد', 'ليان خالد'].map((name) => <div className="team-member" key={name}><span>{name[0]}</span><b>{name}</b><small>منسق عملاء</small></div>)}<button className="add-button"><SafeIcon icon={FiPlus} /> إضافة عضو</button></section>
        <section className="panel settings-section"><h2>اللغة والبيانات</h2><label className="field"><span>لغة التطبيق</span><select><option>العربية</option><option>English</option></select></label><button className="btn secondary"><SafeIcon icon={FiUploadCloud} /> رفع بيانات جديدة</button></section>
      </div>
    </div>
  );
}

function Field({ label, value }) {
  return <label className="field"><span>{label}</span><input defaultValue={value} /></label>;
}

function PageTitle({ title, subtitle }) {
  return <header className="page-header"><div><h1>{title}</h1><p>{subtitle}</p></div></header>;
}